registerComponent("blocks/search-box", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * Três comportamentos, os mesmos de 2020: o submit bloqueado com menos de três
 * caracteres, o "limpar" que aparece quando há texto, e o fechamento da busca
 * do header no celular.
 *
 * O que mudou de mecanismo, e nada mais:
 *
 * - `Is.mobile.ANY()` → `Asa.legado.celular.matches`. O `Is` lia o USER AGENT:
 *   um desktop estreito não fechava a busca e um tablet largo fechava. Agora é
 *   a largura, no mesmo degrau do LESS (`@legacy-maxSm`, 767) — nunca
 *   `Asa.celular`, que é 768 e é do DS.
 * - `keyup` → `input`, pelo mesmo motivo do `blocks/input`: colagem e
 *   autopreenchimento não disparam `keyup`, e o botão de limpar não aparecia.
 *
 * ⚠️ `.toggle-search` está COMENTADO no Blade do header desde antes desta
 * reescrita (pendência 4 do sub-lote 5b), então a busca do header não tem como
 * abrir hoje. O fechar continua ligado, com guarda de nulo: quando o botão
 * voltar, o par volta inteiro.
 */

const formulario = component.querySelector('form');
const campo = component.querySelector('[name="q"]');
const limpar = component.querySelector('.clean-search');
const alternar = document.querySelector('.toggle-search');

const MINIMO_DE_BUSCA = 3;

if (formulario && campo) {
    formulario.addEventListener('submit', function (evento) {
        if (campo.value.length < MINIMO_DE_BUSCA) {
            evento.preventDefault();
        }
    });

    const marcarLimpar = () => {
        if (limpar) {
            limpar.classList.toggle('is-active', campo.value !== '');
        }
    };

    campo.addEventListener('input', marcarLimpar);
    campo.addEventListener('blur', marcarLimpar);

    marcarLimpar();
}

if (limpar && campo) {
    limpar.addEventListener('click', function (evento) {
        evento.preventDefault();

        limpar.classList.remove('is-active');
        campo.value = '';
        campo.focus();

        if (Asa.legado.celular.matches) {
            component.classList.remove('is-active');

            if (alternar) {
                alternar.classList.remove('is-active');
            }
        }
    });
}

});
